import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  templateUrl: './park-led-time-form.html',
  selector: 'park-led-time-form',
  styles: [`
    input.ng-invalid {
      border: 1px solid red;
    }

    button.btn-site {
      background-color: #1365b6;
      color: white;
      border-radius: 4px;
    }

    button.btn-site:disabled {
      background-color: #bdbdbd;
    }
  `]
})

export class ParkLedTimeFormComponent implements OnInit {
  @Input() public ledTime: any;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;
  @Input() public parkId: string;
  @Input() public id: string;

  ledTimeForm: FormGroup;
  inProgress = false;

  constructor(private comm: CommandsService) {
    this.ledTimeForm = new FormGroup({
      january: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      february: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      march: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      april: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      may: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      june: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      july: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      august: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      september: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      october: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      november: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
      december: new FormGroup({
        on_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
        off_time: new FormControl('12:00', [Validators.required, Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')]),
      }),
    });
  }

  ngOnInit() {
    this.ledTimeForm.patchValue({
      january: {
        on_time: this.ledTime.january.onTime,
        off_time: this.ledTime.january.offTime,
      },
      february: {
        on_time: this.ledTime.february.onTime,
        off_time: this.ledTime.february.offTime,
      },
      march: {
        on_time: this.ledTime.march.onTime,
        off_time: this.ledTime.march.offTime,
      },
      april: {
        on_time: this.ledTime.april.onTime,
        off_time: this.ledTime.april.offTime,
      },
      may: {
        on_time: this.ledTime.may.onTime,
        off_time: this.ledTime.may.offTime,
      },
      june: {
        on_time: this.ledTime.june.onTime,
        off_time: this.ledTime.june.offTime,
      },
      july:{
        on_time: this.ledTime.july.onTime,
        off_time: this.ledTime.july.offTime,
      },
      august: {
        on_time: this.ledTime.august.onTime,
        off_time: this.ledTime.august.offTime,
      },
      september: {
        on_time: this.ledTime.september.onTime,
        off_time: this.ledTime.september.offTime,
      },
      october: {
        on_time: this.ledTime.october.onTime,
        off_time: this.ledTime.october.offTime,
      },
      november: {
        on_time: this.ledTime.november.onTime,
        off_time: this.ledTime.november.offTime,
      },
      december: {
        on_time: this.ledTime.december.onTime,
        off_time: this.ledTime.december.offTime,
      },
    });
  }

  onSubmit({value, valid}) {
    if (valid) {
      const data = {};

      Object.keys(value).forEach((key) => {
        data[key] = {
          on_time: moment(value[key].on_time, 'HH:mm').format('HH:mm'),
          off_time: moment(value[key].off_time, 'HH:mm').format('HH:mm'),
        };
      });

      this.inProgress = true;

      this.comm.updateLedTime(this.parkId, this.id, data).then((res) => {
        this.inProgress = false;
        this.setEditMode();
      }).catch((err) => {
        this.inProgress = false;
        alert(err);
      });
    }
  }

  public setEditMode() {
    this.getSearchStatusChange.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-led-time/park-led-time-form.component.ts